export default "__VITE_ASSET__CUzzJCj$__"